import { render, staticRenderFns } from "./exam-inventory-modal.vue?vue&type=template&id=a90ecca8&scoped=true"
import script from "./exam-inventory-modal.vue?vue&type=script&lang=ts"
export * from "./exam-inventory-modal.vue?vue&type=script&lang=ts"
import style0 from "./exam-inventory-modal.vue?vue&type=style&index=0&id=a90ecca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ecca8",
  null
  
)

export default component.exports